import Vue from 'vue';
import Vuex from 'vuex';

import home from './modules/home'  // 首页
import user from './modules/user'  // 用户
import admin from './modules/admin'

Vue.use(Vuex);
// 持久化
import createPersistedstate from 'vuex-persistedstate'

export default new Vuex.Store({
    modules: {
        home,
        user,
        admin
    },
    plugins: [ // 默认存储在localStorage中
    createPersistedstate({
      key: 'longevity-degital-store', // 存储数据的key值
      paths: ['home','user'] // 存储state中的哪些数据，可以是整个子模块的state，也可以是子模块中的具体数据state.profile.token
    })
  ]
})
